import { Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AideSupportService } from 'src/services/aide-support.service';
import { TutorielVideoPlayerComponent } from './tutoriel-video-player/tutoriel-video-player.component';

interface Tutoriel {
  cle: string;
  nomFichierBase: string;
  titre: string;
  vimeoIds: string[];
}

type LangueTutoriel = 'fr' | 'en';

@Component({
    selector: 'app-tutoriels',
    templateUrl: './tutoriels.component.html',
    styleUrls: ['./tutoriels.component.scss'],
    imports: [TranslateModule, MatExpansionModule, MatIcon, MatButtonModule, MatProgressSpinnerModule, TutorielVideoPlayerComponent]
})
export class TutorielsComponent {
  panelOpenState = false;
  chargementTutoriel: { [key: string]: boolean } = {};

  tutoriels: Tutoriel[] = [
    {
      cle: 'CREATION_COMPTE',
      nomFichierBase: 'creation-compte',
      titre: 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.CREATION_COMPTE',
      vimeoIds: []
    },
    {
      cle: 'GUIDE_UTILISATEUR',
      nomFichierBase: 'guide-utilisateur',
      titre: 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.GUIDE_UTILISATEUR',
      vimeoIds: ['1141182763', '1141182727']
    },
    {
      cle: 'GUIDE_ADMINISTRATEUR',
      nomFichierBase: 'guide-administrateur',
      titre: 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.GUIDE_ADMINISTRATEUR',
      vimeoIds: []
    },
    {
      cle: 'GUIDE_PILOTE',
      nomFichierBase: 'guide-pilote',
      titre: 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.GUIDE_PILOTE',
      vimeoIds: []
    },
    {
      cle: 'TABLEAU_DE_BORD',
      nomFichierBase: '',
      titre: 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.TABLEAU_DE_BORD',
      vimeoIds: ['1141182664', '1141182646', '1141182814', '1141182745', '1141182788', '1141182685', '1141182707']
    },
    {
      cle: 'ENTITES_MULTIPLES',
      nomFichierBase: 'entites-multiples',
      titre: 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.ENTITES_MULTIPLES',
      vimeoIds: ['1141182801']
    }/* ,
    {
      cle: 'CONTENUS_PERSONNALISES',
      nomFichierBase: 'contenus-personnalises',
      titre: 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.CONTENUS_PERSONNALISES',
      vimeoIds: []
    } */
  ];

  constructor(private aideSupportService: AideSupportService) { }

  ouvrirTutoriel(tutoriel: Tutoriel, langue: LangueTutoriel): void {
    const cleChargement = `${tutoriel.cle}_${langue}`;
    this.chargementTutoriel[cleChargement] = true;

    const nomFichier = `${tutoriel.nomFichierBase}-${langue}.pdf`;

    this.aideSupportService.obtenirUrlTutoriel(nomFichier).subscribe({
      next: (url) => {
        this.chargementTutoriel[cleChargement] = false;
        window.open(url, '_blank');
      },
      error: (error) => {
        this.chargementTutoriel[cleChargement] = false;
        console.error('Erreur lors de la récupération du tutoriel:', error);
      }
    });
  }
}
